export default __webpack_public_path__ + "static/media/img--design-5.8dc9b555.jpg";